import type { LookerDashboard, LookerFolder } from 'lumen/models';

const isFolderOpen = (
  folder: LookerFolder,
  selectedItem: LookerDashboard | LookerFolder,
): boolean => {
  if (selectedItem.isDeleted) {
    return false;
  }

  // check if selectedReport is in the current folder
  // @ts-expect-error: Argument of type 'string' is not assignable to parameter of type 'never'.
  if (selectedItem && folder.id === selectedItem.belongsTo('folder').id()) {
    return true;
  }

  // check if any of the subfolders has the selectedReport
  if (folder.hasMany('folders').value()) {
    return Boolean(
      (folder.hasMany('folders').value() ?? []).some((f) =>
        isFolderOpen(f, selectedItem),
      ),
    );
  }

  return false;
};

export { isFolderOpen };
